import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  Autocomplete,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Chip,
  FormControl,
  FormHelperText,
  Stack,
  TextField,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MaterialBox from "../../components/MaterialBox";
import { BsFillPersonBadgeFill, BsFillPersonVcardFill } from "react-icons/bs";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";

import {
  appointmentWithDataOptions,
  leadData,
  vendorData,
  customerData,
} from "./appointmentData";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import {
  allContact,
  allCustomer,
  allLeadprospect,
  allVendor,
  getAppointmentDetail,
  getContactdetailByMaster,
  getContactdetailByUser,
  getCustomerByMaster,
  getCustomerByUser,
  getLeadProspectByMaster,
  getLeadProspectByUser,
  getVendorByMaster,
  getVendorByUser,
} from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import {
  addAppoinmentService,
  deleteAppointmentService,
  updateAppointmentService,
} from "../../lib/appUtliz/AppoinmentSercice";
import { useNavigate, useLocation } from "react-router-dom";
import { fromGlobalId } from "../../lib/decoded/rawPk";
import { useLoading } from "../../context/LodingContext";
import { useError } from "../../context/ErrorContext";
import { useSuccess } from "../../context/SucccessContext";
import StatusBar from "./StatusBar";



const allUsersDetail = gql`
  query {
    allUsersDetail {
      id
      username
    }
  }
`;
const today = new Date();
const sevenDaysAgo = new Date();
sevenDaysAgo.setDate(today.getDate() - 7);
const maxDate = today.toISOString().split("T")[0];
const minDate = sevenDaysAgo.toISOString().split("T")[0];






const AppointmentForm = () => {
  const [withData, setWithData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);

  const [inputDisbledOthers, setInputDisbledOthers] = useState(true);
  const [inputDisbled, setInputDisbled] = useState(true);
  const [appointmentWithName, setAppointmentWithName] = useState("");
  const [appotimentSelctStatus, setAppotimentSelctStatus] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus , errormessage, setErrormessage} = useError();
  const [pendingLoading, setPendingLoading] = useState(false);
  const [selectCustomerOption, setSelectCustomerOption] = useState([]);
  const [contactPersonDisbledStatus, setContactDisbledPersonStatus] =
    useState(false);
  const [canEdit, setCanEdit] = useState(true);
  const [latestAppointmentStage, setLatestAppointmentStage] = useState(null);
  const [showReasonInput, setShowReasonInput] = useState(false);
  



  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [selectedEmployee, setSelctedEmploye] = useState([]);

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const navigate = useNavigate();
  const isUser = currentUser?.role;
  const params = useLocation();
  const id = params.search.slice(1);
  const leadName = "Prospect";
  const vendor = "Vendor";
  const customer = "Customer";
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const appointmentOptions=[
    { value: "Scheduled", label: "Scheduled"},
    { value: "Re-Scheduled", label: "Re-Scheduled" },
    { value: "Follow-up", label: "Follow-up"},
    { value: "Cancelled", label: "Cancelled"},
    { value: "Completed", label: "Completed"},
  ];

  const [appointmentData, setAppointmentData] = useState({
    // appointmentData
    scheduledDate: "",
    time: "",
    appoinmentWith: "",
    withName: "",
    contactPerson: "",
    name: "",
    email: "",
    phoneNumber: "",
    description: "",
    opportunity: "",
    appointmentStage: { value: "Scheduled", label: "Scheduled" },
    // appointmentStage: "",
    reason: "",
    
    // appointmentData status
    scheduledDateStatus: "unchecked",
    timeStatus: "unchecked",
    appoinmentWithStatus: "unchecked",
    withNameStatus: "unchecked",
    contactPersonStatus: "unchecked",
    nameStatus: "unchecked",
    emailStatus: "unchecked",
    phoneNumberStatus: "unchecked",
    opportunityStatus: "unchecked",
    descriptionStatus: "unchecked",
    appointmentStageStatus: "success",
    reasonStatus: "success"
  });

  const [opportunities, setOpportunities] = useState([]);
  
  const fetchOpportunities = async (appointmentWith, withName) => {
    if (!appointmentWith || !withName?.value) 
      {
        console.error("Missing required parameters:", { appointmentWith, withName });
      return;
      }

      const customer_or_lead_name= parseInt(withName.value, 10);

      if(isNaN(customer_or_lead_name))
      {
        console.error("error", withName.value);
        return;
      }
  
    try {
      const opportunity = gql`
        query getContactByOpportunity($opportunity_from:String!,$customer_or_lead_name:Int!){
          getContactByOpportunity(opportunityFrom:$opportunity_from,customerOrLeadName:$customer_or_lead_name){
            id
            oppid
          }
        }
      `;
      

      
      const response = await request(BASEURL, opportunity, {
        opportunity_from: appointmentWith, 
        customer_or_lead_name: customer_or_lead_name,
      });
      

      if(!response || !response.getContactByOpportunity){
        console.error("invalid API response", response);
        return;
      }      
      // setOpportunities(response.getContactByOpportunity || []);
      

      setOpportunities(response.getContactByOpportunity.map(opportunity =>
        ({
          value: opportunity.id,
          label: opportunity.oppid
        })
      ));
      
      
    } catch (error) {
      console.error("Error fetching opportunities:", error);
    } 
  };

  useEffect(() => {
    if (appointmentData.appoinmentWith?.label && appointmentData.withName?.value) {
      fetchOpportunities(appointmentData.appoinmentWith.label, appointmentData.withName);
    }
  }, [appointmentData.appoinmentWith?.label, appointmentData.withName?.value]);


  

  const getAppHistory = gql `
  query getapphistory($appintmentid:String!){
    getAppointmenthistoryDetail(appointmentId:$appintmentid){
      id
      appointmentStage
    }
  }
  `


  const fetchAppHistory = async (appointmentId) => {
    try {
      const resp = await request(BASEURL, getAppHistory, {
        appintmentid: appointmentId,
      });
      if (resp?.getAppointmenthistoryDetail) {
        return resp.getAppointmenthistoryDetail;
      } else {
        console.error("No history found for this appointment.");
        return [];
      }
      
    } catch (error) {
      console.error("Error fetching appointment history:", error);
      return [];
    }
  };
  
  const [appointmentStages, setAppointmentStages] = useState([]);

  useEffect(() => {
    if (id) {
      fetchAppHistory(id).then((history) => {
        if (history && history?.length > 0) {
          setAppointmentStages(history);
          const latestStage = history[history.length - 1].appointmentStage;
          setLatestAppointmentStage(latestStage.id);
          const formattedStage = latestStage
            ? { value: latestStage, label: latestStage }
            : { value: "Scheduled", label: "Scheduled" };

            setAppointmentStages(history);
  
          setAppointmentData((prev) => ({
            ...prev,
            appointmentStage: formattedStage,
          }));
        }
      });
    }
  }, [id]);
  
  
  
  

  const handleAppointmentData =  async (event, selectEvent) => {
    
    let appointmentState = { ...appointmentData };
    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "appoinmentWith":
          {
            const appoinmentWithValue = event?.label.toLowerCase();

            setAppointmentWithName(appoinmentWithValue);
            localStorage.setItem("appoinmentWithValue", appoinmentWithValue);

            if (appoinmentWithValue == customer.toLowerCase()) {
              setInputDisbledOthers(false);
              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getCustomerByMaster
                  : isUser.toLowerCase() == "employee"
                  ? getCustomerByUser
                  : isUser.toLowerCase() == "superuser"
                  ? allCustomer
                  : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                console.error(res.allCustomer, "allCustomer");
                setWithData(
                  isUser.toLowerCase() == "manager"
                    ? res.getCustomerdetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getCustomerdetailByUser
                    : isUser.toLowerCase() == "superuser"
                    ? res.allCustomer
                    : []
                );
              });
              setAppotimentSelctStatus(true);
              setContactDisbledPersonStatus(true);
              setAppointmentData((prevData) => ({
                ...prevData,

                withName: { value: "", label: "" },
                withNameStatus: "unchecked",
              }));
            } else if (appoinmentWithValue == vendor.toLowerCase()) {
              setInputDisbledOthers(false);
              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getVendorByMaster
                  : isUser.toLowerCase() == "employee"
                  ? getVendorByUser
                  : isUser.toLowerCase() == "superuser"
                  ? allVendor
                  : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                setWithData(
                  isUser.toLowerCase() == "manager"
                    ? res.getVendordetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getVendordetailByUser
                    : isUser.toLowerCase() == "superuser"
                    ? res.allVendor
                    : []
                );
              });
              setContactDisbledPersonStatus(true);
              setAppotimentSelctStatus(true);
              setAppointmentData((prevData) => ({
                ...prevData,

                withName: { value: "", label: "" },
                withNameStatus: "unchecked",
              }));
              // setWithData(vendorData);
            } else if (appoinmentWithValue == leadName.toLowerCase()) {
              setInputDisbledOthers(false);

              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getLeadProspectByMaster
                  : isUser.toLowerCase() == "employee"
                  ? getLeadProspectByUser
                  : isUser.toLowerCase() == "superuser"
                  ? allLeadprospect
                  : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                setWithData(
                  isUser.toLowerCase() == "manager"
                    ? res.getLeadprospectDetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getLeadprospectDetailByUser
                    : isUser.toLowerCase() == "superuser"
                    ? res.allLeadprospect
                    : []
                );
              });
              setContactDisbledPersonStatus(true);
              setAppotimentSelctStatus(true);
              setAppointmentData((prevData) => ({
                ...prevData,

                withName:"",
                withNameStatus: "unchecked",
              }));
              // setWithData(leadData);
            } else if (appoinmentWithValue == "others") {
              setInputDisbledOthers(true);
              setContactDisbledPersonStatus(false);
              setAppotimentSelctStatus(true);
            } else {
              setAppotimentSelctStatus(true);
              setInputDisbledOthers(true);
              setContactDisbledPersonStatus(false);
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              appointmentState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              if (event?.label == "Others") {
                appointmentState["withName"] = "";
                appointmentState["withNameStatus"] = "unchecked";
              } else {
                appointmentState["withName"] = "";
                appointmentState["withNameStatus"] = "unchecked";
                appointmentState["email"] = "";
                appointmentState["name"] = "";
                appointmentState["phoneNumber"] = "";
                appointmentState["emailStatus"] = "unchecked";
                appointmentState["nameStatus"] = "unchecked";
                appointmentState["phoneNumberStatus"] = "unchecked";
                appointmentState["contactPerson"] = "";
                appointmentState["contactPersonStatus"] = "unchecked";
              }
            } else {
              appointmentState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              appointmentState["withName"] = "";
              appointmentState["withNameStatus"] = "unchecked";
              appointmentState["email"] = "";
              appointmentState["name"] = "";
              appointmentState["phoneNumber"] = "";
              appointmentState["emailStatus"] = "unchecked";
              appointmentState["nameStatus"] = "unchecked";
              appointmentState["phoneNumberStatus"] = "unchecked";
            }
          }
          break;
        case "withName":
            
            // setAppointmentData((prev) => ({
            //   ...prev,
            //   [selectEvent.name] : event,
            // }));
          {
            const orgId = event?.value;
            request(
              BASEURL,
              isUser.toLowerCase() == "manager"
                ? getContactdetailByMaster
                : isUser.toLowerCase() == "employee"
                ? getContactdetailByUser
                : isUser.toLowerCase() == "superuser"
                ? allContact
                : "Data Not Found",
              { id: currentUser?.id }
            ).then((res) => {
              console.error(res, "responsecontact");

              const response =
                isUser.toLowerCase() == "manager"
                  ? res.getContactdetailByMaster
                  : isUser.toLowerCase() == "employee"
                  ? res.getContactdetailByUser
                  : isUser.toLowerCase() == "superuser"
                  ? res.allContact
                  : [];

              const cus = response.filter((val, ind) => {
                if (
                  val.organizationType.toLowerCase() ==
                    appointmentWithName.toLowerCase() &&
                  val.organizationName.toLowerCase() ==
                    event?.label.toLowerCase()
                ) {
                  return val;
                } else {
                  appointmentState["email"] = "";
                  appointmentState["name"] = "";
                  appointmentState["phoneNumber"] = "";
                  appointmentState["emailStatus"] = "unchecked";
                  appointmentState["nameStatus"] = "unchecked";
                  appointmentState["phoneNumberStatus"] = "unchecked";
                  appointmentState["contactPerson"] = "";
                  appointmentState["contactPersonStatus"] = "unchecked";
                }
              });

              setSelectCustomerOption(cus);
            });
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              appointmentState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              appointmentState["email"] = "";
              appointmentState["name"] = "";
              appointmentState["phoneNumber"] = "";
              appointmentState["emailStatus"] = "unchecked";
              appointmentState["nameStatus"] = "unchecked";
              appointmentState["phoneNumberStatus"] = "unchecked";
              appointmentState["contactPerson"] = "";
              appointmentState["contactPersonStatus"] = "unchecked";
            } else {
              appointmentState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              appointmentState["email"] = "";
              appointmentState["name"] = "";
              appointmentState["phoneNumber"] = "";
              appointmentState["emailStatus"] = "unchecked";
              appointmentState["nameStatus"] = "unchecked";
              appointmentState["phoneNumberStatus"] = "unchecked";
              appointmentState["contactPerson"] = "";
              appointmentState["contactPersonStatus"] = "unchecked";
            }
          }
          break;
        case "contactPerson": {

          selectCustomerOption.filter((val) => {
            if (val.id == event?.value) {
              appointmentState["email"] = val.mailId;
              appointmentState["emailStatus"] = "success";
              appointmentState["name"] = val.firstName;
              appointmentState["phoneNumber"] = val.contactNumber;
              appointmentState["nameStatus"] = "success";
              appointmentState["phoneNumberStatus"] = "success";
            }
          });
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.label) === true) {
            appointmentState[selectEvent.name + "Status"] =
              event?.label === undefined ? "unchecked" : "success";
          } else {
            appointmentState[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
            appointmentState["email"] = "";
            appointmentState["emailStatus"] = "unchecked";
            appointmentState["name"] = "";
            appointmentState["phoneNumber"] = "";
            appointmentState["nameStatus"] = "unchecked";
            appointmentState["phoneNumberStatus"] = "unchecked";
          }
        }
      }

      appointmentState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "scheduledDate":
          {
            const alphaNLenghthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "time":
            {
              const alphaNLenghthRegex = new RegExp("^.{2,500}$");
              if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                appointmentState[event.target.name + "Status"] = "success";
              } else {
                appointmentState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "email":
          {
            const alphaNLenghthRegex = new RegExp(
              /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "phoneNumber":
            {
              const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
              if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                appointmentState[event.target.name + "Status"] = "success";
              } else {
                appointmentState[event.target.name + "Status"] =
                  event.target.value === "" ? "unchecked" : "error";
              }
            }
            break;

          case "opportunity":
            {
              
              setAppointmentData(prevData => ({
                  ...prevData,
                  opportunity: event,
              }));
            }
          break;

        // case "opportunity":
        //   {
        //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
        //     if(lengthRegex.text(event.target.value?.trim()))
        //     {
        //       appointmentState[event.name.name + "Status"] = "success";
        //     }
        //     else{
        //       appointmentState[event.target.name + "Status"] = "error";
        //         event.target.value === "" ? "unchecked" : "error";
        //     }
        //   }  
        //   break;
        

        // case "appointmentstage":
        //   {     
        //     const appointmentStageRegex = new RegExp("^[A-Za-z]+( [A-Za-z]+){0,49}$");
        //     if (appointmentStageRegex.test(event.target.value?.trim())) {
        //       appointmentState[event.target.name + "Status"] = "success";
        //     } else {
        //       appointmentState[event.target.name + "Status"] =
        //         event.target.value === "" ? "unchecked" : "error";
        //     }
        //   }
        //   break;

        case "appointmentstage":
          {
            setShowReasonInput(event.value.toLowerCase() === "cancelled");
            setAppointmentData((prevData) => ({
              ...prevData,
              appointmentStage: event,
            }));

          }
          break;
        case "description":
          {
            
            const alphaNLenghthRegex = new RegExp("^.{2,500}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "reason":
          {
            setAppointmentData((prevData) => ({
              ...prevData,
              reasonStatus: event.target.value.trim() ? "success" : "error",
            }));
            const alphaNLenghthRegex = new RegExp("^.{2,500}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        appointmentState[event.target.name] = event.target.value;
      }
    }

    setAppointmentData(appointmentState);
  };

  useEffect(() => {
    setAppointmentData(prevData => ({
        ...prevData,
        opportunityStatus: prevData.opportunity ? "success" : "unchecked",
    }));
  }, [appointmentData.opportunity]);


  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  useEffect(() => {
    request(BASEURL, allUsersDetail).then((res) =>
      setEmployeeData(res.allUsersDetail)
    );
  }, []);

  useEffect(() => {
    if (id) {
      fetcUpdateValue();
    }
  }, [id]);

  const fetcUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getAppointmentDetail, {
        id: id,
      });
  
      const v = res.getAppointmentDetail;
      setSelectedData(v);
      if (v.id == id) {
        setAppointmentData({
          scheduledDate: v.scheduledDate,
          time: v.time,
          appoinmentWith: {
            value: v.appoinmentWith,
            label: v.appoinmentWith,
          },
          withName: {
            value: v.withName,
            label: v.withName,
          },
          contactPerson: {
            value: v.contactPerson,
            label: v.contactPerson,
          },
          name: v.name,
          email: v.email,
          phoneNumber: v.phoneNumber,
          opportunity: 
          { value: v.opportunity?.id, 
            label: v.opportunity?.oppid }
          ,
          appointmentStage: 
          { value: v.appointmentStage, 
            label: v.appointmentStage},
          
          description: v.description,
          reason: v.reason,

          // appointmentData status
          scheduledDateStatus: "success",
          timeStatus: "success",
          appoinmentWithStatus: "success",
          withNameStatus: "success",
          contactPersonStatus: "success",
          nameStatus: "success",
          emailStatus: "success",
          phoneNumberStatus: "success",
          opportunityStatus: "success",
          appointmentStageStatus: "success",
          descriptionStatus: "success",
        });
        const temp = [];
        v.applicationdemoSet?.map((i) => {
          temp?.push(i.appointedPerson
          );
        });

        setSelctedEmploye(temp);
      }
    } catch (err) {}
  };
  // useEffect(() => {
  //   if (inputDisbledOthers) {
  //     setAppointmentData((prevData) => ({
  //       ...prevData,
  //       withName: "",
  //       withNameStatus: "success",
  //     }));
  //   } else if (!inputDisbledOthers) {
  //     setAppointmentData((prevData) => ({
  //       ...prevData,

  //       withName: { value: "", label: "" },
  //       withNameStatus: "unchecked",
  //     }));
  //   }
  // }, [inputDisbledOthers]);

  const checkAllFields = () => {
    let allowSubmit = false;
    const isCancelled = appointmentData.appointmentStage?.value.toLowerCase() === "cancelled";
    const reasonRejex = /^.{2,500}$/;
    const isReasonValid = isCancelled ? reasonRejex.test(appointmentData.reason?.trim() || "") : true;

    if (
      appointmentData.scheduledDateStatus === "success" &&
      appointmentData.timeStatus === "success" &&
      appointmentData.appoinmentWithStatus === "success" &&
      appointmentData.withNameStatus === "success" &&
      // appointmentData.contactPersonStatus === "success" &&
      appointmentData.nameStatus === "success" &&
      appointmentData.emailStatus === "success" &&
      appointmentData.phoneNumberStatus === "success" 
      && appointmentData.appointmentStageStatus === "success"
      //appointmentData.descriptionStatus === "success"
      && isReasonValid
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const handleAddAppointemnt = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setCirleLoading(true);
        const aplicationdemo = selectedEmployee.map((v, i) => {
          return { appointedPerson: v?.id };
        });

        const values = {
          user: rawPk,
          scheduledDate: appointmentData.scheduledDate,
          time: appointmentData.time,
          appoinmentWith: appointmentData.appoinmentWith?.label,
          withName: appointmentData.withName?.label,
          contactPerson: appointmentData.contactPerson?.label,
          name: appointmentData.name,
          email: appointmentData.email,
          phoneNumber: appointmentData.phoneNumber,
          opportunity: appointmentData.opportunity?.value,
          appointmentStage: appointmentData.appointmentStage?.value,
          description: appointmentData.description,
          applicationdemo: aplicationdemo,
          reason: appointmentData.reason || "",
          // reason: appointmentData.reason || showReasonInput ? cancellationReason : null,
        }; 
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const {createStatus,errormessage} = await addAppoinmentService(values);
        setCirleLoading(false);
        // dataStatus ? navigate("/appointment") : alert("err");
        if (createStatus) {
          setSuccessStatus(true);
          setSucessTitle("Appointment Added");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/appointment");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage)
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleCancelAppoinmentData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/appointment");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setAppointmentData((prevData) => ({
      ...prevData,
      scheduledDate: selectedData.scheduledDate,
      time: selectedData.time,
      appoinmentWith: selectedData.appoinmentWith
        ? { value: selectedData.appoinmentWith, label: selectedData.appoinmentWith }
        : prevData.appoinmentWith,
      withName: selectedData.withName
        ? { value: selectedData.withName.value || selectedData.withName, label: selectedData.withName.label || selectedData.withName }
        : prevData.withName, 
      contactPerson: selectedData.contactPerson
        ? { value: selectedData.contactPerson.value || selectedData.contactPerson, label: selectedData.contactPerson.label || selectedData.contactPerson }
        : prevData.contactPerson,
      name: selectedData.name || prevData.name,
      email: selectedData.email || prevData.email,
      phoneNumber: selectedData.phoneNumber || prevData.phoneNumber,
      opportunity: selectedData.opportunity
        ? { value: selectedData.opportunity.id , label: selectedData.opportunity.oppid  }
        : prevData.opportunity,
      appointmentStage: selectedData.appointmentStage 
        ? { value: selectedData.appointmentStage, label: selectedData.appointmentStage }
        : { value: "Scheduled", label: "Scheduled" }, 
      // appointmentStage:  { value: selectedData.appointmentStage, label: selectedData.appointmentStage},
      // appointmentStage: selectedData.appointmentStage ? { value: selectedData.appointmentStage.value || selectedData.appointmentStage , label: appointmentStage.appointmentStage.label || appointmentStage.appointmentStage } : prevData.appointmentStage,
      description: selectedData.description || prevData.description,
      reason: selectedData.reason || "",
      scheduledDateStatus: "success",
      timeStatus: "success",
      appoinmentWithStatus: "success",
      withNameStatus: "success",
      contactPersonStatus: "success",
      nameStatus: "success",
      emailStatus: "success",
      phoneNumberStatus: "success",
      opportunityStatus: "success",
      appointmentStageStatus: "success",
      descriptionStatus: "success",
      reasonStatus: "success"
    }));
  };
  
  const handleupdateAppointment = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          scheduledDate: appointmentData.scheduledDate,
          time: appointmentData.time,
          appoinmentWith: appointmentData.appoinmentWith?.label,
          withName: appointmentData.withName?.label,
          contactPerson: appointmentData.contactPerson?.label,
          name: appointmentData.name,
          email: appointmentData.email,
          phoneNumber: appointmentData.phoneNumber,
          opportunity: appointmentData.opportunity?.value,
          appointmentStage: appointmentData.appointmentStage?.value,
          description: appointmentData.description,
          reason: appointmentData.reason || "",
        };

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const {updateStatus,errormessage} = await updateAppointmentService(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Appointment Updated");
          setAppointmentStages(prevStages => [...prevStages, values.appointmentStage]);
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/appointment");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage)
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleDelteAppointment = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await deleteAppointmentService(id);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Appointment Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/appointment");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const getAppHistoryById = gql`
  query getapphistorybyid($id:String!){
  getAppointmenthistoryDetailbyid(id:$id){
      id
      scheduledDate
      time
      appoinmentWith
      withName
      contactPerson
      name
      email
      phoneNumber
      description
      appointmentStage
      status
      reason
    opportunity{
      id
      oppid
      
    }
    applicationdemohistorySet{
      id
      appointedPerson{
        id
        username
      }
    }
  }
}
`;
// const [latestAppointmentStage, setLatestAppointmentStage] = useState(null);

  const handleStatusClick = async (historyId) => {
    try {
      const response = await request(BASEURL, getAppHistoryById, { id: historyId });
      const historyData = response.getAppointmenthistoryDetailbyid;
      if (historyData) {
        
        setAppointmentData(() => ({
          scheduledDate: historyData.scheduledDate,
          time: historyData.time,
          appoinmentWith: { value: historyData.appoinmentWith, label: historyData.appoinmentWith },
          withName: { value: historyData.withName, label: historyData.withName },
          contactPerson: { value: historyData.contactPerson, label: historyData.contactPerson },
          name: historyData.name,
          email: historyData.email,
          phoneNumber: historyData.phoneNumber,
          description: historyData.description,
          opportunity: historyData.opportunity
            ? { value: historyData.opportunity.id, label: historyData.opportunity.oppid }
            : "",
          appointmentStage: { value: historyData.appointmentStage, label: historyData.appointmentStage },
          reason: historyData.reason,
          // scheduledDateStatus: historyData.scheduledDate ? "success" : "unchecked",
          // timeStatus: historyData.time ? "success" : "unchecked",
          // appoinmentWithStatus: historyData.appoinmentWith ? "success" : "unchecked",
          // withNameStatus: historyData.withName ? "success" : "unchecked",
          // contactPersonStatus: historyData ? "success" : "unchecked",
          // nameStatus: historyData ? "success" : "unchecked",
          // opportunityStatus: historyData.opportunity ? "success" : "unchecked",
          // emailStatus: historyData ? "success" : "unchecked",
          // phoneNumberStatus: historyData.phoneNumber ? "success" : "unchecked",
          // descriptionStatus: historyData.description ? "success" : "unchecked",
          // appointmentStageStatus: historyData.appointmentStage ? "success" : "unchecked",
        }));
        setCanEdit(historyId === latestAppointmentStage);
        setShowReasonInput(historyData.appointmentStage.toLowerCase() === "cancelled");
      }
    } catch (error) {
      console.error("Error fetching history by id:", error);
    }
  };
  const handlemulipleSelect = (event, newValue) => {
    setSelctedEmploye(newValue);
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}

      <Card>
      <StatusBar 
      stages={appointmentStages} 
      onStatusClick={handleStatusClick} 
      disabled={togglePage.edit} />

        <CardHeader
          title={
            <>
              {togglePage.view === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Appointment Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDelteAppointment}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ):togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Appointment Details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                      disabled={!canEdit}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
               : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Appointment Form Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                           <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                           <MaterialTypography
                                           sx={{color:'#460058',fontFamily:'Aptos'}}
                                             component="label"
                                             variant="body2"
                                             fontWeight="700"
                                           >
                                             Appointment Information
                                           </MaterialTypography>
                                         </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Scheduled Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="scheduledDate"
                  type="date"
                  placeholder="ScheduledDate"
                  value={appointmentData.scheduledDate}
                  onChange={handleAppointmentData}
                  error={
                    appointmentData.scheduledDateStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    appointmentData.scheduledDateStatus === "success"
                      ? true
                      : false
                  }
                  inputProps={{
                    min: minDate,
                  }}
                  disabled={togglePage?.view === true ? true : false}
                />
                {appointmentData.scheduledDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Schedulated Date
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Time <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="time"
                  type="time"
                  placeholder="eg. 01-01-2024"
                  value={appointmentData.time}
                  onChange={handleAppointmentData}
                  error={appointmentData.timeStatus === "error" ? true : false}
                  success={
                    appointmentData.timeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {appointmentData.timeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter a Valid Time</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Appointment With <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="appoinmentWith"
                  value={appointmentData.appoinmentWith}
                  // defaultValue={{ label: "Mr." }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleAppointmentData} //selectedValue, event
                  options={appointmentWithDataOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.lable,
                    };
                  })}
                  error={
                    appointmentData.appoinmentWithStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    appointmentData.appoinmentWithStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Organization Name{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="withName"
                  value={appointmentData.withName}
                  // defaultValue={{ label: "Mr." }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleAppointmentData} //selectedValue, event
                  options={withData.map((value) => {
                    return {
                      value: value.id,
                      label:
                        appointmentWithName == leadName.toLowerCase()
                          ? value.companyName
                          : value.legalName,
                    };
                  })}
                  error={
                    appointmentData.withNameStatus === "error" 
                  }
                  success={
                    appointmentData.withNameStatus === "success" 
                  }
                  isClearable
                  isDisabled={togglePage?.view === true ? true : inputDisbledOthers}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Person <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="contactPerson"
                  value={appointmentData.contactPerson}
                  // defaultValue={{ label: "Mr." }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleAppointmentData} //selectedValue, event
                  options={selectCustomerOption.map((value) => {
                    return {
                      value: value.id,
                      label: value.firstName,
                    };
                  })}
                  error={
                    appointmentData.contactPersonStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    appointmentData.contactPersonStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                  isDisabled={!contactPersonDisbledStatus}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  placeholder="Enter Your Name"
                  value={appointmentData.name}
                  onChange={handleAppointmentData}
                  error={appointmentData.nameStatus === "error" ? true : false}
                  success={
                    appointmentData.nameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {appointmentData.nameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be Maximum 25 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Email <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="email"
                  placeholder="Enter your email"
                  value={appointmentData.email}
                  onChange={handleAppointmentData}
                  error={appointmentData.emailStatus === "error" ? true : false}
                  success={
                    appointmentData.emailStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {appointmentData.emailStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter Valid Email Address</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="phoneNumber"
                  placeholder="Enter your phonenumber"
                  value={appointmentData.phoneNumber}
                  onChange={handleAppointmentData}
                  error={
                    appointmentData.phoneNumberStatus === "error" ? true : false
                  }
                  success={
                    appointmentData.phoneNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {appointmentData.phoneNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter a Valid PhoneNumber</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                  Opportunity ID
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                name="opportunity"
                value={appointmentData.opportunity}
                customStyles= {{optionPadding:20}}
                onChange={handleAppointmentData}

                options={opportunities?.map((opportunity) => ({
                  value: opportunity.value || opportunity.id,
                  label: opportunity.label || opportunity.id,
                }))}

                isClearable
                error={
                  appointmentData.opportunityStatus === "error" ? true : false
                }
                success={
                  appointmentData.opportunityStatus === "success"
                    ? true
                    : false
                }
                isDisabled={togglePage?.view === true ? true : false}
              />
                
                    
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Appointment Stage <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                name="appointmentstage"
                value={appointmentData.appointmentStage}
                customStyles= {{optionPadding: 20}}
                  onChange={(option) => {
                  if (togglePage.edit) {
                    setAppointmentData(prev => ({
                      ...prev,
                      appointmentStage: option
                    }));
                    setShowReasonInput(option.value.toLowerCase() === "cancelled");
                  }
                }}
                options={appointmentOptions}
                isDisabled={!togglePage.edit}
                success={true}
                />
                
        
                </Grid>
                <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  placeholder="Write Description..."
                  value={appointmentData.description}
                  onChange={handleAppointmentData}
                  error={
                    appointmentData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    appointmentData.descriptionStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {appointmentData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description Should be maximum 500 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {appointmentData.appointmentStage?.value.toLowerCase() === "cancelled" && (
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  placeholder="Reason for Cancellation..."
                  value={appointmentData.reason}
                  onChange={handleAppointmentData}
                  disabled={togglePage?.view === true }
                  error={appointmentData.reasonStatus === "error"}
                  success={ appointmentData.reasonStatus === "success" ? true : false}
                  />
                  {appointmentData.reasonStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Reason is required when cancelling an appointment
                      </FormHelperText>
                    </FormControl>
                  )}
              </Grid>
              )}
            </Grid>
            <div style={{ marginTop: "25px" }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Add demo
                </MaterialTypography>
              </MaterialBox>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={employeeData}
                getOptionLabel={(option) => `${option.username}`} // Custom display format
                value={selectedEmployee}
                onChange={handlemulipleSelect}
                disabled={togglePage?.view === true ? true : false}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={`${option.username}`} // Customize tag display
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Add demo " />
                )}
              />
            </div>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleupdateAppointment}
                >
                  Submit
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddAppointemnt}
                >
                  Submit
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleCancelAppoinmentData}
                >
                  Cancel
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AppointmentForm;
